// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-selector-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.dataset-selector {
  flex: 1;
}
.dataset-selector ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.content {
  overflow-y: auto;
  padding: var(--content-margin);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 16px;
  color: var(--text-secondary);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 8px;
  color: var(--text-secondary);
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}
.empty-state p {
  margin: 0;
  font-size: 12px;
  opacity: 0.7;
}

.dataset-detail {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.warning-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  font-weight: 500;
}
.warning-banner mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.section-count {
  font-size: 12px;
  color: var(--text-secondary);
}

.compact-table {
  width: 100%;
}
.compact-table th {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
}
.compact-table td {
  font-size: 13px;
}
.compact-table tr.mat-mdc-row {
  height: 40px;
}
.compact-table tr.mat-mdc-header-row {
  height: 32px;
}

.clickable-row {
  cursor: pointer;
}
.clickable-row:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.empty-section {
  padding: 24px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 13px;
  border: 1px dashed rgba(255, 255, 255, 0.2);
  border-radius: 8px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.actions button mat-icon {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/assets-widget/assets-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;AACF;AAEI;EACE,aAAA;AAAN;;AAKA;EACE,gBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,4BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,4BAAA;AAFF;AAIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFJ;AAKE;EACE,SAAA;EACA,eAAA;EACA,YAAA;AAHJ;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,gBAAA;AAJF;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AALF;;AAQA;EACE,eAAA;EACA,4BAAA;AALF;;AAQA;EACE,WAAA;AALF;AAOE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;AALJ;AAQE;EACE,eAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EACE,YAAA;AARJ;;AAYA;EACE,eAAA;AATF;AAWE;EACE,2CAAA;AATJ;;AAaA;EACE,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;AAVF;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,8CAAA;AAVF;AAYE;EACE,iBAAA;AAVJ","sourcesContent":[".dataset-selector-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.dataset-selector {\n  flex: 1;\n\n  ::ng-deep {\n    .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n  }\n}\n\n.content {\n  overflow-y: auto;\n  padding: var(--content-margin);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 16px;\n  color: var(--text-secondary);\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 8px;\n  color: var(--text-secondary);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    opacity: 0.5;\n  }\n\n  p {\n    margin: 0;\n    font-size: 12px;\n    opacity: 0.7;\n  }\n}\n\n.dataset-detail {\n  position: relative;\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n.warning-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  background-color: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n  font-weight: 500;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.section-header {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.section-title {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.section-count {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.compact-table {\n  width: 100%;\n\n  th {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary);\n  }\n\n  td {\n    font-size: 13px;\n  }\n\n  tr.mat-mdc-row {\n    height: 40px;\n  }\n\n  tr.mat-mdc-header-row {\n    height: 32px;\n  }\n}\n\n.clickable-row {\n  cursor: pointer;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n  }\n}\n\n.empty-section {\n  padding: 24px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 13px;\n  border: 1px dashed rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n\n  button mat-icon {\n    margin-right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
